module.exports = __webpack_public_path__ + "static/media/dario_alineador_1800.4f9baffb.jpg";